import { useState, useEffect, useRef } from "react";

const useInputField = ({ initialValue = "", validate }) => {
    const [value, setValue] = useState(initialValue);
    const [isDirty, setIsDirty] = useState(false);
    const [error, setError] = useState(null);
    const initialSet = useRef(false);

    useEffect(() => {
        if (validate) {
            setError(validate(value));
        }
    }, [value, validate]);

    useEffect(() => {
        if (!initialSet.current && initialValue !== undefined) {
            setValue(initialValue);
            setIsDirty(false);
            initialSet.current = true;
        }
    }, [initialValue]);

    const onChange = (e) => {
        setValue(e.target.value);
        setIsDirty(true);
    };

    const reset = (newValue = initialValue) => {
        setValue(newValue);
        setIsDirty(false);
        setError(null);
    };

    return {
        value,
        setValue,
        onChange,
        isDirty,
        error,
        reset,
    };
};

export default useInputField;
